import React from 'react';
import { InstagramEmbed } from 'react-social-media-embed';

import type { InstagramBlock as InstagramBlockType } from '@/blocks/instagram-embed';

interface InstagramBlockProp {
  block: InstagramBlockType;
}

export const InstagramBlock: React.FC<InstagramBlockProp> = ({ block }) => {
  return (
    <div className="flex h-full w-full justify-center">
      <InstagramEmbed url={block.url} width={block.width} />
    </div>
  );
};
